import React from "react";
import { Link } from "react-router-dom";
import { BackIcon } from "../../../../components/icons";
import { useTranslation } from "react-i18next";

const BookingHeader = ({ id, customer, bookingKey }) => {
    const { t } = useTranslation();
    return (
        <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-6 tw:pb-[28px] tw:lg:pb-[42px] tw:px-5">
            <Link
                to={id ? `/booking-detail/${id}` : "/my-page/bookings"}
                className="tw:inline-flex tw:items-center tw:gap-[10px] tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-[#e8e8e8] tw:px-3 tw:py-2 tw:text-[#282828] tw:!no-underline"
            >
                <BackIcon color="#8D8D8D" width={7} height={10} />
                <span className="tw:font-hanken-grotesk tw:text-[#282828]">{t("editBooking.BookingEditPage.header.back")}</span>
            </Link>
            <div className="tw:flex tw:flex-col">
                <div className="tw:font-hanken-grotesk tw:font-medium tw:text-[13px] tw:lg:text-[15px] tw:text-[#7c7b7b]">
                    {t("editBooking.BookingEditPage.header.bookingFor", {
                        customerName: `${customer?.pronounced} ${customer?.name}`,
                        bookingId: bookingKey
                    })}
                </div>
                <div className="tw:font-hanken-grotesk tw:text-[22px] tw:lg:text-[30px] tw:font-semibold tw:leading-normal tw:text-[#212529]">
                    {t("editBooking.BookingEditPage.header.editBooking")}
                </div>
            </div>
        </div>
    );
};

export default BookingHeader;
